<template>
  <div class="jurisdiction-navigation">
    <span
      :class="{ disabled: currentJurisdictionIndex === 0 }"
      class="jurisdiction-navigation-item"
      @click="$router.push({
        name: 'JurisdictionDetail',
        params: {
          id: jurisdictionsList[currentJurisdictionIndex - 1].id,
        }
      })"
    >
      <i class="bi bi-caret-left-fill" />
      {{ $t('words.previous') }}
    </span>
    <span
      :class="{ disabled: currentJurisdictionIndex === jurisdictionsList.length - 1 }"
      class="jurisdiction-navigation-item"
      @click="$router.push({
        name: 'JurisdictionDetail',
        params: {
          id: jurisdictionsList[currentJurisdictionIndex + 1].id,
        }
      })"
    >
      {{ $t('words.next') }}
      <i class="bi bi-caret-right-fill" />
    </span>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'JurisdictionNavigation',

  computed: {
    ...mapState('jurisdiction', [
      'jurisdictionsList'
    ]),
    ...mapGetters('jurisdiction', [
      'currentJurisdictionIndex'
    ])
  },
};
</script>

<style lang="less" scoped>
.jurisdiction-navigation {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
  .jurisdiction-navigation-item {
    cursor: pointer;
    color: @blue;
    font-style: italic;
    font-weight: 600;
  }
  .jurisdiction-navigation-item:hover {
    text-shadow: 0 0 0.03rem @blue;
  }
  .jurisdiction-navigation-item.disabled {
    pointer-events: none;
    opacity: 0.6;
  }
}
</style>